export const appLinks = {
    androidAppUrl: 'https://play.google.com/store/apps/details?id=com.farfisa.infinity',
    iosAppUrl: 'https://apps.apple.com/it/app/ip-evo/id1672017179'
};
